// FLAGS: none
// Assembles the correlation headers every API call carries. It propagates the browsing-session id and
// trace context; it does not mint, authorize or store them — those decisions live in
// `services/sessionStorage.service.ts` and `appInsights/AppInsights.ts`.
import i18n from "@src/i18n";
import sessionStorageService from "@src/services/sessionStorage.service";
import { getTraceHeaders } from "@src/appInsights/AppInsights";

/**
 * The headers every call to the OpenUp API carries: the locale, the client
 * marker the API uses to tell MyOpenUp traffic apart, the browsing-session
 * correlator `SessionCorrelationMiddleware` promotes into App Insights, and the
 * trace pair.
 *
 * Shared so the axios request interceptor and the unload-time `fetch` — which
 * cannot go through axios and so misses its interceptors — send the same set.
 * Anything added here reaches both.
 */
export const buildApiRequestHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    "Accept-Language": i18n.language,
    "User-Agent-Operating-System": "MyOpenUp",
  };

  const userSessionId = sessionStorageService.getUserSessionIdFromStorage();
  if (userSessionId) {
    headers["X-User-Session-Id"] = userSessionId;
  }

  const traceHeaders = getTraceHeaders();
  if (traceHeaders) {
    headers.traceparent = traceHeaders.traceParent;
    headers["Request-Id"] = traceHeaders.requestId;
  }

  return headers;
};
